import { FooterTypes } from '@dtx-company/true-common/src/types/footer'
import { TWITTER_LABEL } from '@app/code/src/components/molecules/destination-icon'

export const footerMock: FooterTypes = {
  socialmedia: [
    {
      logo: {
        dimensions: {
          width: 40,
          height: 40
        },
        alt: 'Navigate to Facebook',
        copyright: null,
        url: '/icons/facebook-outline.svg'
      },
      link: {
        link_type: 'Web',
        url: 'https://www.facebook.com/GetFlowcode/',
        target: '_blank'
      }
    },
    {
      logo: {
        dimensions: {
          width: 40,
          height: 40
        },
        alt: 'Navigate to Instagram',
        copyright: null,
        url: '/icons/instagram-outline-white.svg'
      },
      link: {
        link_type: 'Web',
        url: 'https://www.instagram.com/getflowcode/',
        target: '_blank'
      }
    },
    {
      logo: {
        dimensions: {
          width: 40,
          height: 40
        },
        alt: `Navigate to ${TWITTER_LABEL}`,
        copyright: null,
        url: '/icons/social-media/twitter-white.svg'
      },
      link: {
        link_type: 'Web',
        url: 'https://twitter.com/Flowcode',
        target: '_blank'
      }
    },
    {
      logo: {
        dimensions: {
          width: 40,
          height: 40
        },
        alt: 'Navigate to Youtube',
        copyright: null,
        url: '/icons/social-media/youtube-filled-white.svg'
      },
      link: {
        link_type: 'Web',
        url: 'https://www.youtube.com/c/getflowcode',
        target: '_blank'
      }
    },
    {
      logo: {
        dimensions: {
          width: 41,
          height: 40
        },
        alt: 'Navigate to LinkedIn',
        copyright: null,
        url: '/icons/linkedin-filled.svg'
      },
      link: {
        link_type: 'Web',
        url: 'https://www.linkedin.com/company/flowcode-qr/mycompany/',
        target: '_blank'
      }
    },
    {
      logo: {
        dimensions: {
          width: 1870,
          height: 2137
        },
        alt: 'TikTok Logo',
        copyright: null,
        url: '/icons/tiktok-filled-white.svg'
      },
      link: {
        link_type: 'Web',
        url: 'https://www.tiktok.com/@getflowcode',
        target: '_blank'
      }
    }
  ],
  trademark: [
    {
      text: [
        {
          type: 'paragraph',
          text: 'Flowcode is a trademark of the dtx company',
          spans: []
        }
      ]
    },
    {
      text: [
        {
          type: 'paragraph',
          text: `©${new Date().getFullYear()} the dtx company`,
          spans: []
        }
      ]
    }
  ],
  mobilelinks: [
    {
      link_id: [],
      text: 'Blog',
      link: {
        link_type: 'Web',
        url: 'https://www.flowcode.com/blog'
      }
    },
    {
      link_id: [],
      text: 'FAQs',
      link: {
        link_type: 'Web',
        url: 'https://help.flowcode.com/en/articles/7061692-table-of-contents',
        target: '_blank'
      }
    },
    {
      link_id: [],
      text: 'Contact Us',
      link: {
        link_type: 'Web',
        url: 'mailto:partner@flowcode.com'
      }
    },
    {
      link_id: [],
      text: 'Privacy Policy',
      link: {
        link_type: 'Web',
        url: 'https://www.flowcode.com/privacy-policy'
      }
    },
    {
      link_id: [],
      text: 'Notice at Collection',
      link: {
        link_type: 'Web',
        url: 'https://www.flowcode.com/privacy-policy#notice-at-collection'
      }
    },
    {
      link_id: [],
      text: 'Terms of Use',
      link: {
        link_type: 'Web',
        url: 'https://www.flowcode.com/terms-of-use'
      }
    },
    {
      link_id: [],
      text: 'Privacy Request',
      link: {
        link_type: 'Web',
        url: 'https://www.flowcode.com/privacyrequest'
      }
    },
    {
      link_id: [
        {
          type: 'paragraph',
          text: 'cookie-preferences',
          spans: []
        }
      ],
      text: 'Cookie Preferences',
      link: {
        link_type: 'Web',
        url: 'https://www.flowcode.com'
      }
    },
    {
      link_id: [
        {
          type: 'paragraph',
          text: 'your-privacy-choices',
          spans: []
        }
      ],
      text: 'Your Privacy Choices',
      link: {
        link_type: 'Web',
        url: 'https://www.flowcode.com/privacyrequest'
      }
    }
  ],
  body: [
    {
      primary: {
        title: [
          {
            type: 'heading4',
            text: 'Company',
            spans: []
          }
        ]
      },
      items: [
        {
          link_id: [],
          text: [
            {
              type: 'paragraph',
              text: 'Our team',
              spans: []
            }
          ],
          link: {
            link_type: 'Web',
            url: 'https://www.flowcode.com/team',
            target: '_blank'
          }
        },
        {
          link_id: [],
          text: [
            {
              type: 'paragraph',
              text: 'Careers',
              spans: []
            }
          ],
          link: {
            link_type: 'Web',
            url: 'https://www.flowcode.com/careers'
          }
        },
        {
          link_id: [],
          text: [
            {
              type: 'paragraph',
              text: 'Press',
              spans: []
            }
          ],
          link: {
            link_type: 'Web',
            url: 'https://www.flowcode.com/press',
            target: '_blank'
          }
        },
        {
          link_id: [],
          text: [
            {
              type: 'paragraph',
              text: 'Blog',
              spans: []
            }
          ],
          link: {
            link_type: 'Web',
            url: 'https://www.flowcode.com/blog',
            target: '_blank'
          }
        }
      ]
    },
    {
      primary: {
        title: [
          {
            type: 'heading4',
            text: 'Terms',
            spans: []
          }
        ]
      },
      items: [
        {
          link_id: [],
          text: [
            {
              type: 'paragraph',
              text: 'Privacy Policy',
              spans: []
            }
          ],
          link: {
            link_type: 'Web',
            url: 'https://www.flowcode.com/privacy-policy'
          }
        },
        {
          link_id: [],
          text: [
            {
              type: 'paragraph',
              text: 'Notice at Collection',
              spans: []
            }
          ],
          link: {
            link_type: 'Web',
            url: 'https://www.flowcode.com/privacy-policy#notice-at-collection'
          }
        },
        {
          link_id: [],
          text: [
            {
              type: 'paragraph',
              text: 'Terms of Use',
              spans: []
            }
          ],
          link: {
            link_type: 'Web',
            url: 'https://www.flowcode.com/terms-of-use'
          }
        },
        {
          link_id: [],
          text: [
            {
              type: 'paragraph',
              text: 'Privacy Request',
              spans: []
            }
          ],
          link: {
            link_type: 'Web',
            url: 'https://www.flowcode.com/privacyrequest'
          }
        },
        {
          link_id: [],
          text: [
            {
              type: 'paragraph',
              text: 'Patent Notice',
              spans: []
            }
          ],
          link: {
            link_type: 'Web',
            url: 'https://www.flowcode.com/patentnotice',
            target: '_blank'
          }
        },
        {
          link_id: [
            {
              type: 'paragraph',
              text: 'cookie-preferences',
              spans: []
            }
          ],
          text: [
            {
              type: 'paragraph',
              text: 'Cookie Preferences',
              spans: []
            }
          ],
          link: {
            link_type: 'Web',
            url: 'https://www.flowcode.com'
          }
        },
        {
          link_id: [
            {
              type: 'paragraph',
              text: 'your-privacy-choices',
              spans: []
            }
          ],
          text: [
            {
              type: 'paragraph',
              text: 'Your Privacy Choices',
              spans: []
            }
          ],
          link: {
            link_type: 'Web',
            url: 'https://www.flowcode.com/privacyrequest'
          }
        }
      ]
    },
    {
      primary: {
        title: [
          {
            type: 'heading4',
            text: 'Resources',
            spans: []
          }
        ]
      },
      items: [
        {
          link_id: [],
          text: [
            {
              type: 'paragraph',
              text: 'Help center',
              spans: []
            }
          ],
          link: {
            link_type: 'Web',
            url: 'https://help.flowcode.com/en/',
            target: '_blank'
          }
        },
        {
          link_id: [],
          text: [
            {
              type: 'paragraph',
              text: 'FAQs',
              spans: []
            }
          ],
          link: {
            link_type: 'Web',
            url: 'https://help.flowcode.com/en/articles/7061692-table-of-contents',
            target: '_blank'
          }
        },
        {
          link_id: [],
          text: [
            {
              type: 'paragraph',
              text: 'Plans',
              spans: []
            }
          ],
          link: {
            link_type: 'Web',
            url: 'https://www.flowcode.com/plans',
            target: '_blank'
          }
        },
        {
          link_id: [],
          text: [
            {
              type: 'paragraph',
              text: 'Industries',
              spans: []
            }
          ],
          link: {
            link_type: 'Web',
            url: 'https://www.flowcode.com/industry',
            target: '_blank'
          }
        }
      ]
    },
    {
      primary: {
        title: [
          {
            type: 'heading4',
            text: 'Try us out',
            spans: []
          }
        ]
      },
      items: [
        {
          link_id: [
            {
              type: 'paragraph',
              text: '',
              spans: []
            }
          ],
          text: [
            {
              type: 'paragraph',
              text: 'Free QR Code Generator',
              spans: []
            }
          ],
          link: {
            link_type: 'Web',
            url: 'https://www.flowcode.com/free-qr-code-generator'
          }
        },
        {
          link_id: [],
          text: [
            {
              type: 'paragraph',
              text: 'Flowpage',
              spans: []
            }
          ],
          link: {
            link_type: 'Web',
            url: 'https://www.flowcode.com/page'
          }
        },
        {
          link_id: [],
          text: [
            {
              type: 'paragraph',
              text: 'FlowcodeTV',
              spans: []
            }
          ],
          link: {
            link_type: 'Web',
            url: 'https://www.flowcode.com/tv'
          }
        },
        {
          link_id: [],
          text: [
            {
              type: 'paragraph',
              text: 'Flowcode Pro',
              spans: []
            }
          ],
          link: {
            link_type: 'Web',
            url: 'https://www.flowcode.com/pro'
          }
        },
        {
          link_id: [
            {
              type: 'paragraph',
              text: '',
              spans: []
            }
          ],
          text: [
            {
              type: 'paragraph',
              text: 'Flowcode Pro+',
              spans: []
            }
          ],
          link: {
            link_type: 'Web',
            url: 'https://www.flowcode.com/use-cases/proplus',
            target: '_blank'
          }
        },
        {
          link_id: [],
          text: [
            {
              type: 'paragraph',
              text: 'Enterprise',
              spans: []
            }
          ],
          link: {
            link_type: 'Web',
            url: 'https://www.flowcode.com/enterprise',
            target: '_blank'
          }
        }
      ]
    },
    {
      primary: {
        title: [
          {
            type: 'heading4',
            text: 'Contact us',
            spans: []
          }
        ]
      },
      items: [
        {
          link_id: [],
          text: [
            {
              type: 'paragraph',
              text: 'Support',
              spans: []
            }
          ],
          link: {
            link_type: 'Web',
            url: 'mailto:support@flowcode.com',
            target: '_blank'
          }
        },
        {
          link_id: [],
          text: [
            {
              type: 'paragraph',
              text: 'Sales',
              spans: []
            }
          ],
          link: {
            link_type: 'Web',
            url: 'mailto:partner@flowcode.com',
            target: '_blank'
          }
        },
        {
          link_id: [],
          text: [
            {
              type: 'paragraph',
              text: 'Public relations',
              spans: []
            }
          ],
          link: {
            link_type: 'Web',
            url: 'mailto:press@flowcode.com',
            target: '_blank'
          }
        },
        {
          link_id: [],
          text: [
            {
              type: 'paragraph',
              text: 'General inquiries',
              spans: []
            }
          ],
          link: {
            link_type: 'Web',
            url: 'mailto:support@flowcode.com',
            target: '_blank'
          }
        }
      ]
    }
  ]
}
